import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IntegrationService } from '../integration.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

  constructor(private router:Router,private _integrationService:IntegrationService) { }
  email = ''
  password = ''
  clicked = false;

  ngOnInit() {
  }

  updateEmail(value:string){
    // console.log('hello')
    this.email = value;
    console.log(this.email)
  }

  updatePassword(value:string){
    // console.log('pass1')
    this.password = value;
    
  }
  authenticateUser(){
    this.clicked = true;
    this._integrationService.authenticateUser(this.email,this.password)
    this.clicked = false;
  }

}
